<template>

  <v-layout
    row
    fill-height
    v-touch:start="touchStart"
    v-touch:end="touchEnd"
    v-touch:moving="touchMoving"
  >
    <v-flex xs12>
      <div
        class="touch-loading text-xs-center d-block"
        :class="{'loading': loading}"
        :style="{'top': touchLoadingY + 'px', 'opacity': ((progress - 5) / 100), 'z-index': 1}"
      >
        <v-avatar :size="55" color="white">
          <v-progress-circular
            fixed
            :rotate="-90"
            :indeterminate="loading"
            :value="progress"
            :size="35"
            :width="4"
            color="primary"
            class="d-inline-block"
          ></v-progress-circular>
        </v-avatar>
      </div>
      <v-card flat class="py-4" v-show="loaded && items.length === 0">
        <v-card-text>
          <em>Vous n'avez aucune campagne actuellement.</em>
        </v-card-text>
      </v-card>
      <v-list three-line class="py-0">
        <template v-for="(item, index) in items">
          <v-divider
            :key="index"
          ></v-divider>
          <v-list-tile
            ripple
            :class="{ grey : isOdd(index), 'lighten-5' : isOdd(index) }"
            :key="item.id"
            @click="selectSolicitationAssignation(index)"
          >
            <v-list-tile-content>
                <v-list-tile-title :class="{'primary--text' : currentSolicitationAssignation && currentSolicitationAssignation.id === item.id}" v-html="item.label"></v-list-tile-title>
                <v-list-tile-sub-title v-show="item.stats.local_updated || item.stats.local_remaining">
                  <span class="secondary--text">{{ item.stats.local_updated /* item.total_scored */ }} rejoints</span>
                  /
                  <span class="text--secondary">{{ item.stats.local_remaining /* item.stats.total_remaining || item.total_qualified */ }} sur la liste</span>
                </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon v-show="currentSolicitationAssignation && currentSolicitationAssignation.id === item.id" color="primary">star</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
        <v-divider
          :key="'end-divider'"
        ></v-divider>
      </v-list>
    </v-flex>
    <v-snackbar
      v-model="snackbar"
      color="dark"
      :timeout="6000"
      class="ma-2"
      flat
      @click="snackbar = false"
    >
      Aucune connexion
    </v-snackbar>
  </v-layout>

</template>

<script>

import { Auth } from '../auth'
import { Exchanger } from '../exchanger.js'
import { nSQL } from "@nano-sql/core"

const DEFAULT_TOUCH_LOADING_Y = -45;
const SWIPE_REFRESH_DISTANCE = 180;

export default {
  data () {
    return {
      items: [],
      progress: 0,
      loaded: false,
      loading: false,
      snackbar: false,
      touchStartY: null,
      currentSolicitationAssignation: {},
      touchLoadingY: DEFAULT_TOUCH_LOADING_Y,
    }
  },

  methods: {
    touchStart(ev) {
      this.progress = 0;
      this.touchStartY = ev.changedTouches && window.scrollY === 0 && ! this.loading
        ? ev.changedTouches[0].clientY
        : null;
    },

    touchEnd(ev) {
      if (null === this.touchStartY) {
        return;
      }

      let deltaY = ev.changedTouches[0].clientY - this.touchStartY;

      if (deltaY > SWIPE_REFRESH_DISTANCE && ! Exchanger.isOffline()) {
        this.loading = true;
        Exchanger.pullSolicitationAssignations();
      } else {
        this.touchLoadingY = DEFAULT_TOUCH_LOADING_Y;
        this.progress = 0;

        if (Exchanger.isOffline()) {
          this.snackbar = true;
        }
      }
    },

    touchMoving(ev) {
      if (null === this.touchStartY) {
        return;
      }

      let deltaY = ev.changedTouches[0].clientY - this.touchStartY;

      if (deltaY > 0) {
        this.touchLoadingY = deltaY / 2 > 100 ? 100 : deltaY / 2;
        const deltaProgress = Math.round(deltaY / SWIPE_REFRESH_DISTANCE * 100);

        this.progress = deltaProgress >= 100 ? 100 : deltaProgress;
      }
    },

    selectSolicitationAssignation: function (index) {
      const solicitationAssignation = this.items[index];

      Auth.setCurrentSolicitationAssignationId(solicitationAssignation.id).then(function() {
        this.$router.push({ name: 'campaigns.current' });
      }.bind(this));
    },

    isOdd(number) {
      return (number % 2) !== 0;
    },

    async refreshItems() {
      if (! Auth.isAuthenticated()) {
        this.items = [];
        this.loaded = true;

        return;
      }

      setTimeout(function () {
        this.touchLoadingY = DEFAULT_TOUCH_LOADING_Y;
        this.loading = false;
        this.progress = 0;
      }.bind(this), 250);

      const solicitationAssignationRecords = await nSQL('solicitation_assignations')
        .query("select")
        .where(["user_id", "=", Auth.user().id])
        .exec();

        for (let i = 0, len = solicitationAssignationRecords.length; i < len; i++) {
          let solicitationAssignationRecord = solicitationAssignationRecords[i];

          solicitationAssignationRecord.stats = {
            total_scored: 0,
            total_qualified: 0,
            total_remaining: 0,
          };

          const statsMetricNames = ['total_qualified', 'total_scored', 'total_remaining', 'pushed_at'];

          for (let i = 0, len = statsMetricNames.length; i < len; i++) {
            let metricName = statsMetricNames[i];
            let settingName = `solicitation-assignations:${solicitationAssignationRecord.id}:${metricName}`;

            let settingRows = await nSQL('settings')
              .query('select')
              .where(['name', '=', settingName])
              .exec();

            solicitationAssignationRecord.stats[metricName] = settingRows[0] ? settingRows[0].value : 0;
          }

          let localUpdatedResult = await nSQL("solicitation_lists")
            .query("select", ["COUNT(*) AS local_updated"])
            .where((sl) => {
              return sl.solicitation_assignation_id === solicitationAssignationRecord.id
                && sl.locally_updated_at;
            })
            .exec();

          solicitationAssignationRecord.stats['local_updated'] = localUpdatedResult[0] ? localUpdatedResult[0].local_updated : 0;

           let localScoredResult = await nSQL("solicitation_lists")
            .query("select", ["COUNT(*) AS local_scored"])
            .where((sl) => {
              return sl.solicitation_assignation_id === solicitationAssignationRecord.id
                && sl.score && sl.score !== 'AB';
            })
            .exec();

          solicitationAssignationRecord.stats['local_scored'] = localScoredResult[0] ? localScoredResult[0].local_scored : 0;

          let localRemainingResult = await nSQL("solicitation_lists")
            .query("select", ["COUNT(*) AS local_remaining"])
            .where((sl) => {
              return sl.solicitation_assignation_id === solicitationAssignationRecord.id
                && ! sl.remotely_deleted
                && ! sl.locally_deleted
            })
            .exec();

          solicitationAssignationRecord.stats['local_remaining'] = localRemainingResult[0] ? localRemainingResult[0].local_remaining : 0;
        }

        this.items = solicitationAssignationRecords;

        this.loaded = true;
    },

    refreshCurrentSolicitationAssignation: function () {
      if (Auth.isAuthenticated()) {
        const currentSolicitationAssignationPromise = Auth.getCurrentSolicitationAssignation();

        if (currentSolicitationAssignationPromise) {
          currentSolicitationAssignationPromise.then(function (currentSolicitationAssignation) {
            this.currentSolicitationAssignation = currentSolicitationAssignation || {}
          }.bind(this))
        }
      } else {
        this.currentSolicitationAssignation = {};
      }
    },
  },

  mounted() {
    Auth.$on('current-solicitation-assignation-changed', function () {
      this.refreshCurrentSolicitationAssignation();
    }.bind(this));

    Exchanger.$on('solicitation-assignations-pulled', function () {
      this.refreshItems();
    }.bind(this));

    Exchanger.pullSolicitationAssignations();

    this.refreshCurrentSolicitationAssignation();
    this.refreshItems();
  }
}

</script>

<style>
  .touch-loading {
    position:absolute;
    left:0;
    width:100%;
  }
  .touch-loading.loading {
    margin-top:-60px;
    transition: margin 60ms ease-in-out, box-shadow 60ms ease-in-out;
  }
  .v-progress-circular__overlay {
    transition: none !important;
  }
</style>
